import { render } from "./SectionedContent.vue?vue&type=template&id=705ebe93"
import script from "./SectionedContent.vue?vue&type=script&lang=js"
export * from "./SectionedContent.vue?vue&type=script&lang=js"

import "./SectionedContent.vue?vue&type=style&index=0&id=705ebe93&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__